import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/containers/NewsPage.tsx");
